import { Link } from "react-router-dom";
import { Table, Card, Button } from "antd";
import moment from "moment";

const TABLE_SCROLL_Y = 360;

const DEFAULT_CUSTOMER_INVOICE_COLUMNS = [
	{
		title: "Invoice",
		dataIndex: "id",
		key: "id",
		width: 90,
	},
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		width: 110,
		render: (date) => moment(date).format("ll"),
	},
	{
		title: "Total Amount",
		dataIndex: "total_amount",
		key: "total_amount",
		minWidth: 110,
	},
	{
		title: "Discount",
		dataIndex: "discount",
		key: "discount",
		width: 95,
		responsive: ["md"],
	},
	{
		title: "Due Amount",
		dataIndex: "due_amount",
		key: "due_amount",
		minWidth: 100,
		responsive: ["md"],
	},
	{
		title: "Paid Amount",
		dataIndex: "paid_amount",
		key: "paid_amount",
		minWidth: 115,
		responsive: ["md"],
	},
	{
		title: "Profit",
		dataIndex: "profit",
		key: "profit",
		width: 90,
		responsive: ["md"],
	},
	{
		title: "Action",
		dataIndex: "id",
		key: "payment",
		width: 95,
		render: (id) => (
			<Link to={`/payment/customer/${id}`}>
				<Button type="primary" size="small">
					Payment
				</Button>
			</Link>
		),
		fixed: "right",
	},
];

function CustomerInvoiceList({ list, linkTo = "/sale", columns: columnsProp, scroll: scrollProp, embedded }) {
	const columnsWithLink = (cols) =>
		cols.map((col) =>
			col.key === "id"
				? { ...col, render: (id) => <Link to={`${linkTo}/${id}`}>{id}</Link> }
				: col.key === "payment"
				? { ...col, render: (id) => (
						<Link to={`/payment/customer/${id}`}>
							<Button type="primary" size="small">Payment</Button>
						</Link>
				  ) }
				: col
		);
	const columns = columnsProp ?? columnsWithLink(DEFAULT_CUSTOMER_INVOICE_COLUMNS);
	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));
	const scroll = scrollProp ?? { x: true, y: TABLE_SCROLL_Y };

	const table = (
		<div className="detail-page-table-wrap">
			<Table
				scroll={scroll}
				loading={!list}
				columns={columns}
				dataSource={list ? addKeys(list) : []}
				size="small"
			/>
		</div>
	);

	if (embedded) {
		return table;
	}

	return (
		<div className="customer-invoice-list-section mt-3">
			<Card
				className="header-solid h-full"
				bordered={false}
				title={[
					<h5 key="title" className="font-semibold m-0 text-center">
						Customer Invoice Information
					</h5>,
				]}
				bodyStyle={{ paddingTop: "0" }}>
				{table}
			</Card>
		</div>
	);
}

export default CustomerInvoiceList;
export { DEFAULT_CUSTOMER_INVOICE_COLUMNS };
